import { render, staticRenderFns } from "./delegatairemodale.vue?vue&type=template&id=47de54a6&scoped=true"
import script from "./delegatairemodale.vue?vue&type=script&lang=js"
export * from "./delegatairemodale.vue?vue&type=script&lang=js"
import style0 from "./delegatairemodale.vue?vue&type=style&index=0&id=47de54a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de54a6",
  null
  
)

export default component.exports